<!-- 送货单列表 -->
<template>
  <div class="wrapper">
    <div class="topTitle">
      <span class="left">送货单列表</span>
    </div>
    <el-divider></el-divider>
    <div class="searchCont">
      <el-row :gutter="30">
        <el-col
          v-for="item in selectList"
          :key="item.id"
          :span="item.spanl"
        >
          <!-- 普通input -->
          <div v-if="item.type === 'input'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-input
              class="right"
              size="small"
              :placeholder="item.placeholder"
              v-model="item.value"
              clearable
            >
            </el-input>
          </div>
          <!-- 2个input组成范围区间 -->
          <div v-if="item.type === 'inputRange'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <div class="right">
              <el-input
                class="inpl"
                size="small"
                :placeholder="item.placeholdertxt[0] || '请输入'"
                v-model="item.value[0]"
                clearable
              >
              </el-input>
              <span class="line">-</span>
              <el-input
                class="inpr"
                size="small"
                :placeholder="item.placeholdertxt[1] || '请输入'"
                v-model="item.value[1]"
                clearable
              >
              </el-input>
            </div>
          </div>
          <!-- 下拉选择 -->
          <div v-if="item.type === 'select'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-select
              class="right"
              size="small"
              v-model="item.value"
              :multiple="item.single === 2"
              :placeholder="item.placeholder"
              clearable
              collapse-tags
            >
              <el-option
                v-for="tag in item.option"
                :key="tag.value"
                :label="tag.label"
                :value="tag.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 下拉选择远程搜索 -->
          <div v-if="item.type === 'selectFilter'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-select
              class="right"
              size="small"
              v-model="item.value"
              :multiple="item.single === 2"
              :placeholder="item.placeholder"
              clearable
              collapse-tags
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="selectloading">
              <el-option
                v-for="tag in item.option"
                :key="tag.value"
                :label="tag.label"
                :value="tag.value">
              </el-option>
            </el-select>
          </div>
          <!-- 时间选择-->
          <div v-if="item.type === 'dateTime'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-date-picker
              class="right"
              size="small"
              v-model="item.value"
              type="datetime"
              :placeholder="item.placeholder"
            >
            </el-date-picker>
          </div>
          <!-- 日期选择 -->
          <div v-if="item.type === 'inputDate'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-date-picker
              class="right"
              value-format="yyyy-MM-dd"
              size="small"
              v-model="item.value"
              type="date"
              :placeholder="item.placeholder"
            >
            </el-date-picker>
          </div>
          <!-- 日期区间 -->
          <div v-if="item.type === 'dateRange'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-date-picker
              class="right"
              style="max-width:420px"
              value-format="yyyy-MM-dd"
              size="small"
              v-model="item.value"
              type="daterange"
              range-separator="-"
              start-placeholder="选择开始时间"
              end-placeholder="结束时间"
              :editable="false"
              clearable
            >
            </el-date-picker>
          </div>
          <!-- 日期时间区间 -->
          <div v-if="item.type === 'dateTimeRange'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-date-picker
              class="right"
              style="max-width:420px"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              v-model="item.value"
              type="datetimerange"
              range-separator="-"
              start-placeholder="选择开始时间"
              end-placeholder="结束时间"
              :editable="false"
              clearable
            >
            </el-date-picker>
          </div>
          <!-- 日期选择 年月-->
          <div  v-if="item.type === 'monthTime'" class="itemWrap">
            <span class="left">{{ item.label }}</span>
            <el-date-picker
              class="right"
              value-format="yyyy-MM"
              size="small"
              v-model="item.value"
              type="month"
              :placeholder="item.placeholder">
            </el-date-picker>
          </div>
        </el-col>
        <div class="btnGroup" style="float:right;margin-top:3px;">
          <el-button
            class="small"
            size="small"
            type="primary"
            @click="onSearch"
            :loading="tableLoading"
            >查询</el-button
          >
          <el-button class="small" size="small" @click="onReset">重置</el-button
          >
        </div>
      </el-row>
    </div>
    <div class="exportbtn" style="float:right;margin-bottom:16px;">
      <el-button
        class="small"
        size="small"
        type="primary"
        icon="el-icon-upload2"
        :loading="downLoading"
        @click="exportFile"
        >导出</el-button
      >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      size="small"
      v-loading="tableLoading"
      style="min-height:100px"
      class="myTable"
    >
      <el-table-column
        v-for="(item,index) in columnList"
        :key="index"
        :show-overflow-tooltip="true"
        :prop="item.prop"
        :label="item.col"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <!-- 司机是否需要操作APP -->
          <span v-if="scope.column.property==='driverOperateType'">{{sjsfxyczFormat(scope.row.driverOperateType)}}</span>
          <span v-else>{{(scope.row[scope.column.property] && scope.row[scope.column.property] !== 'null') ? scope.row[scope.column.property] : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="80">
        <template slot-scope="scope">
          <el-button type="text" @click="checkDetail(scope.row)" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as selectConfig from '../common/select.js';
import * as columns from '../common/column.js';
import * as utils from '../common/format.js';
export default {
  data() {
    return {
      selectList: selectConfig.selectListItem2,
      selectloading: false,
      downLoading: false,
      columnList: columns.columnListS,
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      sjsfxyczFormat: utils.sjsfxyczFormat,
      states: [],
      selfilterList: [],
      timer: null
    };
  },
  created() {},
  mounted() {
    this.getTableData();
  },
  methods: {
    ...mapActions([
      'manifestGetTableDataApi',
      'manifestNameSearchApi',
      'manifestExportApi',
    ]),
    // 货主名称输入远程接口货主数据
    remoteMethod(val) {
      if (val !== '') {
        if(this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.selectloading = true;
          let parama = {};
          parama.dataType = 2;  //1提货单 2送货单
          parama.customerName = val;
          this.manifestNameSearchApi(parama).then((response) => {
            this.states = response;
            this.selfilterList = this.states.map(item => {
              return {value: item, label: item};
            });
            this.selectloading = false;
            this.selectList[0].option = this.selfilterList.filter(item => {
              return item.label.toLowerCase().indexOf(val.toLowerCase()) > -1;
            });
          },
            (response) => {
              this.selectloading = false;
          }
          );
        },200);
      } else {
        this.selectList[0].option = [];
      }
    },
    // 查询
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    // 重置
    onReset() {
      this.selectList.forEach(item => {
        item.value = item.initialVal
      })
    },
    // 查看
    checkDetail(row) {
      sessionStorage.setItem('manifestDeatilParama',JSON.stringify(
        {
          dataType: '2',
          goodsOrderId: row.goodsOrderId,
          outerOrderId: row.outerOrderId
        }
      ))
      this.$router.push('/manage/orderSetManifestDetail');
    },
    getHostUrl() {
      return location.protocol + "//" + location.host;
    },
    // 导出
    exportFile() {
      this.downLoading = true;
      let parama = {};
      this.selectList.forEach((item) => {
        if (item.bfield === "planDate") {
          if (item.value) {
            parama["operateStartTm"] = item.value[0];
            parama["operateEndTm"] = item.value[1];
          } else {
            parama["operateStartTm"] = "";
            parama["operateEndTm"] = "";
          }
        } else {
          parama[item.bfield] = item.value;
        }
      });
      parama.dataType = 2;  //1提货单 2送货单
      this.manifestExportApi(parama).then((response) => {
        this.downLoading = false;
        if(response.fileName) {
          window.location.href = this.getHostUrl() + "/saas/downLoad/downLoadOssFile?objectName=" + response.fileName;
        }
      },
        (response) => {
          this.downLoading = false;
      }
      );
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let parama = {};
      this.selectList.forEach((item) => {
        if (item.bfield === "planDate") {
          if (item.value) {
            parama["operateStartTm"] = item.value[0];
            parama["operateEndTm"] = item.value[1];
          } else {
            parama["operateStartTm"] = "";
            parama["operateEndTm"] = "";
          }
        } else {
          parama[item.bfield] = item.value;
        }
      });
      parama.dataType = 2;  //1提货单 2送货单
      parama.pageNum = parseInt(this.currentPage);
      parama.pageSize = parseInt(this.pageSize);
      this.manifestGetTableDataApi(parama).then((response) => {
          this.tableLoading = false;
          this.tableData = response.rows;
          this.totalCount = response.totalCount;
        },
          (response) => {
            this.tableLoading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = parseInt(val);
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = parseInt(val);
      this.getTableData();
    },
  }
};
</script>
<style lang="less" scoped>
.wrapper{
  padding: 0 12px !important;
  /deep/ .el-row {
    margin: 0 !important;
  }
  /deep/ .el-col {
    margin: 4px 0 !important;
    padding-right: 0 !important;
  }
  /deep/ .el-pagination {
    text-align: right;
  }
  /deep/ .cell {
    padding-right: 10px !important;
    box-sizing: border-box;
  }
  .topTitle{
    padding-top: 16px !important;
    margin-bottom: 22px !important;
    display: flex;
    align-items: center;
    .left{
      font-size: 20px;
      color: #000000;
      font-weight: 500;
      box-sizing: border-box;
      margin-right: 16px !important;
    }
    .right{
      font-size: 14px;
      color: #666666;
    }
  }
  .searchCont {
    margin-top: 22px !important;
    margin-bottom: 16px !important;
    .itemWrap {
      display: flex;
      align-items: center;
      .left {
        width: 96px;
        text-align: right;
        margin-right: 12px !important;
        font-size: 14px;
        color: rgba(0,0,0,0.85);
        text-align: right;
        font-weight: 400;
      }
      .right {
        flex: 1;
        display: flex;
        align-items: center;
        .inpl {
          flex: 1;
        }
        .line {
          padding: 0 6px;
          color: rgba(0, 0, 0, 0.25);
        }
        .inpr {
          flex: 1;
        }
      }
    }
  }
  .detailCont{
    padding: 14px 22px !important;
    .t1{
      font-size: 16px;
      color: #000000;
    }
    .basecont,
    .othercont{
      overflow: hidden;
      margin-top: 8px !important;
      .itemcont{
        .item{
          float: left;
          width: 33.333%;
          padding: 8px 0 !important;
          padding-right: 8px !important;
          box-sizing: border-box;
          display: flex;
          align-items: top;
          line-height: 19px;
          .left{
            font-size: 14px;
            color: #888888;
          }
          .right{
            flex: 1;
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }
    
  }
}
</style>